import { __rest } from "tslib";
import { Tooltip } from '../../../../../BaseComponents';
import React from 'react';
const WithTooltip = (_a) => {
    var { title, children } = _a, props = __rest(_a, ["title", "children"]);
    return !!title ? (React.createElement(Tooltip, Object.assign({ title: title }, props), children)) : (children);
};
export default WithTooltip;
